var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Preact from 'preact';
import * as SvgIcon from '../A_SvgIcon';
/** Made by opening the svg exported from figma and manually copying the relevant bits into an
 * SvgIcon (and removing fill so it obeys colour setting).
 * Please see https://mui.com/material-ui/icons/#svgicon
 */
export function WarningChange(props) {
    return (Preact.h(SvgIcon.Component, __assign({ width: "25", height: "24", viewBox: "0 0 25 24", xmlns: "http://www.w3.org/2000/svg", fill: "none" }, props),
        Preact.h("path", { d: "M11.5 13H13.5V7H11.5V13ZM21.5 4H15.5V10L17.7 7.8C18.8 8.9 19.5 10.3 19.5 12C19.5 14.6 17.8 16.8 15.5 17.6V19.7C19 18.8 21.5 15.7 21.5 12C21.5 9.8 20.6 7.8 19.1 6.4L21.5 4ZM11.5 17H13.5V15H11.5V17ZM3.5 12C3.5 14.2 4.4 16.2 5.9 17.6L3.5 20H9.5V14L7.3 16.2C6.2 15.1 5.5 13.7 5.5 12C5.5 9.4 7.2 7.2 9.5 6.3V4.3C6.1 5.2 3.5 8.3 3.5 12Z" })));
}
